import { render, staticRenderFns } from "./DriveTypeTable.vue?vue&type=template&id=02cb8cfb&scoped=true"
import script from "./DriveTypeTable.vue?vue&type=script&lang=js"
export * from "./DriveTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cb8cfb",
  null
  
)

export default component.exports